module.exports = __webpack_public_path__ + "static/scale-model-of-arlington-museum-of-art-in-arlington-texas-f7c3fb58458917d8e11730865a227fec.png";